import React, { useEffect, useRef } from "react";
import { Editor } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor.css";
import "./style.css";

interface Props {
  value: string;
  disabled?: boolean;
  placeholder?: string;
  onBlur: (markdown: string) => void;
}

const toolbarItems = [
  ["heading", "bold", "italic"],
  ["ul", "ol", "indent", "outdent"],
  ["table", "link"],
];

const MarkdownTextArea: React.FC<Props> = ({
  value,
  disabled,
  placeholder,
  onBlur,
}) => {
  const editorRef = useRef<Editor>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const didInit = useRef(false);

  useEffect(() => {
    if (!didInit.current) return;
    editorRef.current?.getInstance().setMarkdown(value || "");
  }, [value]);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    // Custom logic to force outer wrapper to be the same height as inner div that is resizable
    const wwContainer = wrapper.querySelector(
      ".toastui-editor-ww-container"
    ) as HTMLElement;
    if (!wwContainer) return;

    const observer = new ResizeObserver(
      () =>
        (wrapper.style.height = `${
          wwContainer?.offsetHeight > 0 ? wwContainer.offsetHeight + 32 : 132
        }px`)
    );

    observer.observe(wwContainer);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapperRef} className="markdownTextArea">
      {/* @ts-ignore*/}
      <Editor
        ref={editorRef}
        initialValue={value || ""}
        initialEditType="wysiwyg"
        hideModeSwitch
        usageStatistics={false}
        toolbarItems={toolbarItems}
        height="100%"
        placeholder={placeholder}
        onBlur={() => {
          if (editorRef.current)
            onBlur(editorRef.current.getInstance().getMarkdown());
        }}
        //@ts-ignore
        readOnly={disabled}
        autofocus={false}
      />
    </div>
  );
};

export default MarkdownTextArea;
